export default function onlyOnce(fn) {
    return function() {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, arguments);
    };
}



//////////////////
// WEBPACK FOOTER
// ./~/async-es/internal/onlyOnce.js
// module id = b5AN
// module chunks = 0